import { IGeneralInformation, IResponsibleUsers, IRetailSalesAndVolume, IPackageAndBranding, ICompetitorInformation, IVoteResults  } from "@/types/TastingPanel.types";

export const GeneralInformationInitial:IGeneralInformation={
    title:"",
    panelType:"",
    reviewNotes:"",
    businessCategory:"",
    reasonForDevelopment:"",
    diversificationSku:"",
    businessNeed:"",
    productType:"",
    sellingPeriod:"",
    countryOfOrigin:"",
    vendorCorporateName:"",
    vendorEmailAddress:"",
    newOrExistingVendor:"",
    categoryManagerUserId:"",
    ideaId:"",
    vendorAssessmentId:"",
    vendorId:"",
    tastingPanelRevisionCount: 0,
}

export const ResponsibleUsersInitial:IResponsibleUsers={
    developer:"",
    categoryManagerUser:"",
}

export const RetailSalesAndVolumeInitial:IRetailSalesAndVolume={
    estWeeklySales:undefined,
    estWeeklyUnitVol:undefined,
    retailPrice:undefined,
    retailStructure:"",
    regional:"",
}

export const PackageAndBrandingInitial:IPackageAndBranding={
    typeOfPackage:"",
    shelfLife:"",
    expectedLaunchMonth:"",
    size:"",
    packsize:undefined,
    label:"",
    ifBrandedWhy:"",
    requiredAttributes:[],
    preparationMethod:"",
    logistics:"",
    producer:"",
    specialConsiderations:"",
}

export const CompetitorInformationInitial:ICompetitorInformation={
    temporaryId:"initial",
    competitorBrandRetailer:"",
    retailPriceOfCompetitorProduct:undefined,
    sizeOzOfCompetitorProduct:undefined,
}

export const CompetitorInformationDefault:ICompetitorInformation={
    competitorBrandRetailer:"",
    retailPriceOfCompetitorProduct:undefined,
    sizeOzOfCompetitorProduct:undefined,
}

export const VoteResultsInitial:IVoteResults={
    voteResults:"",
    tastingPanelNotes:"",
}